import React from "react";

import PropTypes from "prop-types";

function PaginationItem({ title, current = false, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`py-1 px-3 leading-tight border rounded
       ${
         current
           ? "bg-tertiary border-tertiary text-white"
           : "bg-white border-gray-300 text-gray-400"
       }`}
    >
      {title}
    </button>
  );
}

PaginationItem.propTypes = {
  title: PropTypes.any.isRequired,
  current: PropTypes.bool,
  onClick: PropTypes.func,
};

export default PaginationItem;
